<template>
  <div class="mm-page-main" v-loading="loading">
    <div class="page-header">
      <div class="page-title">添加賬號</div>
      <div @click="pageback" class="page-back">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-back"></use>
        </svg>
      </div>
    </div>
    <div class="pagemain">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px" label-position="left">
        <div class="form-group">
          <div class="form-group-content">
            <div class="mm-row-block">
              <div class="form-isheader-group">
                <div class="group-title">
                  <h3>賬號信息</h3>
                </div>
                <div class="form-isheader-group-content">
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="頭像">
                        <uploadimage :imageUrlList.sync="form.upload_list" listType="picture-card" :fileDir="'avatar'" :watermark="false"></uploadimage>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="員工編號" prop="usernum">
                        <el-input v-model="form.usernum"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="綁定門店" prop="store_id">
                        <el-select v-model="form.store_id" placeholder="請選擇">
                          <el-option label="未綁定" :value="0"></el-option>
                          <el-option v-for="item in storelist" :key="item.id" :label="item.name" :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="賬號" prop="username">
                        <el-input v-model="form.username"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="密碼" prop="password">
                        <el-input v-model="form.password" type="password"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="姓名" prop="name">
                        <el-input v-model="form.name"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="郵箱" prop="email">
                        <el-input v-model="form.email"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="電話" prop="phone">
                        <el-input v-model="form.phone"></el-input>
                      </el-form-item>
                    </div>
                  </div>

                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="性別">
                        <template>
                          <el-radio v-model="form.sex" label="0">男</el-radio>
                          <el-radio v-model="form.sex" label="1">女</el-radio>
                        </template>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="年齡" prop="age">
                        <el-input v-model="form.age"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="狀態">
                        <el-switch v-model="form.status" active-text="啟用" inactive-text="禁用">
                        </el-switch>
                      </el-form-item>

                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="form-submit">
          <el-button @click="formsubmit('form')" type="primary">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import uploadimage from "@/components/Uploadimage.vue"
export default {
  components: {
    uploadimage
  },
  data() {
    return {
      loading: false,
      showpicurl: '',
      showpicbox: false,
      value1: 0,
      ordertype: -1,
      storelist: [],
      form: {
        store_id:0,
        sex: '0',
        status: true,
        upload_list: []
      },
      rules: {
        username: [{
          required: true,
          message: '請輸入登錄賬戶',
        },
        {
          pattern: /^[A-Za-z0-9]+$/,
          message: '只能輸入大小寫字母和數字'
        }
        ],
        password: [{
          required: true,
          message: '請設置登錄密碼',
        },
        {
          pattern: /^[\S]+$/,
          message: '只能輸入可見字符'
        },
        {
          pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)(?![\d_!@#$%^&*`~()-+=]+$)(?![a-zA-Z_!@#$%^&*`~()-+=]+$)[0-9A-Za-z_!@#$%^&*`~()-+=]{6,15}$/,
          message: '密碼必須包含字母和數字,長度在6至15個字符',
          trigger: 'blur'
        }
        ],
        email: [{
          message: '請輸入郵箱地址',
        },
        {
          type: 'email',
          message: '請輸入正確的郵箱地址',
          trigger: 'blur'
        }
        ],
        phone: [{
          message: '請輸入電話號碼',
        },
        {
          pattern: /^[0-9]+$/,
          message: '只能輸入數字'
        },
        ],
        name: [{
          required: true,
          message: '請輸入姓名',
        }],
        age: [{
          pattern: /^[0-9]{1,2}$/,
          message: '只能輸入0-100之間的數字'
        }],

      }
    };
  },
  methods: {
    getstore() {
      this.post('/api/store/index', {
      }).then((res) => {
        this.storelist = res;
      }).catch((err) => {
      })
    },
    pageback() {
      this.$router.go(-1);
    },
    formsubmit(form) {
      this.$refs[form].validate((valid) => {

        if (valid) {
          this.loading = true;
          let data = this.form;
          this.post('/api/user/addsave', {
            data: data
          }).then((res) => {
            if (res == 'usered') {
              this.$message({
                showClose: true,
                message: '用戶名已存在，請重新輸入！',
                type: 'error',
              });
            } else if (res == 'success') {
              this.$message({
                showClose: true,
                message: '添加賬號成功！',
                type: 'success',
                onClose: (() => {
                })
              });
              this.pageback();
            }

            this.loading = false;
          }).catch((err) => {
            this.loading = false;
            console.log(err)
          });
        }
      });
    }
  },
  created() {
    this.getstore();
  }

};
</script>
<style scoped>
.mm-row {
  width: 50%;
}
</style>
